import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React from "react";
import Button from "../button/button.component.js";
import Progress from "../progress/progress.component.js";
import {ButtonSubmitContainer, ButtonSubmitContent, FormActionsContainer, ProgressContainer} from "./form.styles.js";
function FormActions({
  isSubmitting,
  actionButtons,
  onCancel
}) {
  const {
    t
  } = useTranslation();
  if (actionButtons) {
    return actionButtons(isSubmitting);
  }
  return /* @__PURE__ */ React.createElement(FormActionsContainer, null, /* @__PURE__ */ React.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: onCancel,
    disabled: isSubmitting
  }, t("actions.cancel")), /* @__PURE__ */ React.createElement(ButtonSubmitContainer, {
    isSubmitting
  }, /* @__PURE__ */ React.createElement(Button, {
    type: "submit",
    disabled: isSubmitting
  }, /* @__PURE__ */ React.createElement(ButtonSubmitContent, null, t("actions.submit"))), /* @__PURE__ */ React.createElement(ProgressContainer, null, /* @__PURE__ */ React.createElement(Progress, {
    size: "1.3rem",
    circular: true
  }))));
}
export default /* @__PURE__ */ React.memo(FormActions);
